import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { useStore } from "../context/StoreContext";
import ProductCard from "../components/ProductCard";
import Seo from "../components/Seo";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState(null);

  useEffect(() => {
    api("/products").then((all) => setProducts(all.filter((p) => wishlist.includes(p.slug)))).catch(() => setProducts([]));
  }, [wishlist]);

  return (
    <div className="bg-candy-mist min-h-screen">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 py-12">
        <Seo title="Your Wishlist" path="/wishlist" noindex />
        <h1 data-testid="wishlist-heading" className="font-display font-semibold text-3xl sm:text-4xl text-center">Your wishlist</h1>
        {products === null ? (
          <p className="text-center text-muted font-bold mt-20">Fluffing the pillows…</p>
        ) : products.length === 0 ? (
          <div className="text-center py-20" data-testid="wishlist-empty">
            <p className="text-5xl mb-4" aria-hidden="true">💝</p>
            <h2 className="font-display font-semibold text-2xl">Nothing saved yet</h2>
            <p className="text-muted mt-2">Tap the heart on any creation to save it for later.</p>
            <Link to="/shop" data-testid="wishlist-shop-cta" className="mt-6 inline-block px-6 py-3 rounded-full bg-candy text-white font-bold shadow-pink hover:bg-candy-deep transition-colors duration-200">Browse creations</Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-10" data-testid="wishlist-grid">
            {products.map((p, i) => <ProductCard key={p.slug} product={p} index={i} />)}
          </div>
        )}
      </div>
    </div>
  );
}
